import React from 'react';

export default function ViewCarePlan({ carePlan }) {
  return <div className="card axs-shadow mt-4">
    <div className="card-header">
      <div className="row">
        <div className="col">
          <h6>Care Plan</h6>
        </div>
      </div>
    </div>
    <div className="card-body">
      <h6>Physical Exam</h6>
      <p>{carePlan.physicalExam}</p>

      <h6>Imaging</h6>
      <p>{carePlan.imaging}</p>

      <h6>Diagnosis</h6>
      <p>{carePlan.diagnosis}</p>

      <h6>Care Plan</h6>
      <p>{carePlan.carePlan}</p>

      <h6>Attachments</h6>
      <ul className="list-group">
        {carePlan.attachments.data.map((attachment, i) => {
          return <li key={i} className="list-group-item"><a href={attachment.url} target="_blank" rel="noopener noreferrer">{attachment.name}</a></li>
        })}
      </ul>
    </div>
  </div>
}